/* Correlated native Shopify enquiry response; never a server-authenticated receipt. */
(function (window, document) {
  "use strict";
  if (window.DRSKNN_SHOPIFY_ENQUIRY_COMPLETION) return;
  window.DRSKNN_SHOPIFY_ENQUIRY_COMPLETION = true;
  const FORMS = { "/pages/contact": "ContactForm", "/pages/ads-origin-laser-assessment-men": "OriginTikTokAssessmentEnquiry" };
  const ORIGINS = ["https://drsknn.com", "https://www.drsknn.com"];
  const KEY = "drsknn_shopify_enquiry_receipts_v1";
  const CONTEXT_KEY = "drsknn_enquiry_context_v1:", CONTEXT_TTL = 90 * 24 * 60 * 60 * 1000;
  const DENIAL_KEYS = { analytics: CONTEXT_KEY + "analytics-denied:", ads: CONTEXT_KEY + "ads-denied:" };
  const ATTEMPT_TTL = 30 * 60 * 1000, OUTCOME_TTL = 48 * 60 * 60 * 1000;
  const GA4 = "G-FC6YQ8SVMM", MAX_RECORDS = 100;
  const path = window.location.pathname.replace(/\/$/, "");
  if (!ORIGINS.includes(window.location.origin)) return;
  let timer = null, activeUntil = 0;
  const CONTEXT_URL = "https://drsknn-marketing.onrender.com/ingest/enquiry-context";
  const CONTEXT_MAX_TRIES = 8, CONTEXT_RETRY_MAX = 60000;
  const inflight = new Map();
  const validDigest = value => typeof value === "string" && /^[a-f0-9]{64}$/.test(value);
  const validReference = value => typeof value === "string" && /^web-enquiry:[a-f0-9]{8}-[a-f0-9]{4}-4[a-f0-9]{3}-[89ab][a-f0-9]{3}-[a-f0-9]{12}$/.test(value);

  // Synchronous SHA-256 avoids delaying or losing the native form POST. Only
  // the named email field is read; raw email and the enquiry body are not stored.
  function emailDigest(value) {
    if (typeof value !== "string" || typeof TextEncoder !== "function") return "";
    const email = value.trim().toLowerCase();
    if (email.length > 320 || !/^[^\s@]+@[^\s@]+$/.test(email)) return "";
    const bytes = new TextEncoder().encode(email);
    const size = Math.ceil((bytes.length + 9) / 64) * 64;
    const buffer = new Uint8Array(size);
    buffer.set(bytes); buffer[bytes.length] = 128;
    const view = new DataView(buffer.buffer);
    view.setUint32(size - 4, bytes.length * 8, false);
    const constants = [0x428a2f98,0x71374491,0xb5c0fbcf,0xe9b5dba5,0x3956c25b,0x59f111f1,0x923f82a4,0xab1c5ed5,
      0xd807aa98,0x12835b01,0x243185be,0x550c7dc3,0x72be5d74,0x80deb1fe,0x9bdc06a7,0xc19bf174,
      0xe49b69c1,0xefbe4786,0x0fc19dc6,0x240ca1cc,0x2de92c6f,0x4a7484aa,0x5cb0a9dc,0x76f988da,
      0x983e5152,0xa831c66d,0xb00327c8,0xbf597fc7,0xc6e00bf3,0xd5a79147,0x06ca6351,0x14292967,
      0x27b70a85,0x2e1b2138,0x4d2c6dfc,0x53380d13,0x650a7354,0x766a0abb,0x81c2c92e,0x92722c85,
      0xa2bfe8a1,0xa81a664b,0xc24b8b70,0xc76c51a3,0xd192e819,0xd6990624,0xf40e3585,0x106aa070,
      0x19a4c116,0x1e376c08,0x2748774c,0x34b0bcb5,0x391c0cb3,0x4ed8aa4a,0x5b9cca4f,0x682e6ff3,
      0x748f82ee,0x78a5636f,0x84c87814,0x8cc70208,0x90befffa,0xa4506ceb,0xbef9a3f7,0xc67178f2];
    const state = [0x6a09e667,0xbb67ae85,0x3c6ef372,0xa54ff53a,0x510e527f,0x9b05688c,0x1f83d9ab,0x5be0cd19];
    const rotate = (x, n) => (x >>> n) | (x << (32 - n));
    for (let offset = 0; offset < size; offset += 64) {
      const words = new Uint32Array(64);
      for (let i = 0; i < 16; i++) words[i] = view.getUint32(offset + i * 4, false);
      for (let i = 16; i < 64; i++) {
        const x = words[i - 15], y = words[i - 2];
        words[i] = (words[i - 16] + (rotate(x, 7) ^ rotate(x, 18) ^ (x >>> 3)) + words[i - 7] +
          (rotate(y, 17) ^ rotate(y, 19) ^ (y >>> 10))) >>> 0;
      }
      let [a,b,c,d,e,f,g,h] = state;
      for (let i = 0; i < 64; i++) {
        const t1 = (h + (rotate(e, 6) ^ rotate(e, 11) ^ rotate(e, 25)) + ((e & f) ^ (~e & g)) + constants[i] + words[i]) >>> 0;
        const t2 = ((rotate(a, 2) ^ rotate(a, 13) ^ rotate(a, 22)) + ((a & b) ^ (a & c) ^ (b & c))) >>> 0;
        h = g; g = f; f = e; e = (d + t1) >>> 0; d = c; c = b; b = a; a = (t1 + t2) >>> 0;
      }
      [a,b,c,d,e,f,g,h].forEach((value, i) => { state[i] = (state[i] + value) >>> 0; });
    }
    return state.map(value => value.toString(16).padStart(8, "0")).join("");
  }
  function reference(id) {
    return "web-enquiry:" + id.slice(0,8) + "-" + id.slice(8,12) + "-4" + id.slice(13,16) + "-" +
      ((parseInt(id[16],16) & 3) | 8).toString(16) + id.slice(17,20) + "-" + id.slice(20);
  }
  function captureEnquiry(form, id) {
    try {
      const email = form.querySelector('input[name="contact[email]"]');
      if (!email || typeof form.appendChild !== "function") return null;
      const digest = emailDigest(email.value);
      if (!validDigest(digest)) return null;
      let field = form.querySelector('input[name="contact[Website enquiry reference]"]');
      if (!field) {
        field = document.createElement("input"); field.type = "hidden";
        field.name = "contact[Website enquiry reference]"; form.appendChild(field);
      }
      field.value = reference(id);
      return { reference: field.value, email_sha256: digest, submitted_at: new Date().toISOString(),
        form_id: form.id, page_path: path, status: "pending", attempts: 0, next_attempt_at: 0 };
    } catch (_) { return null; }
  }
  function cleanContext(value) {
    if (!value || !validReference(value.reference) || !validDigest(value.email_sha256) ||
        FORMS[value.page_path] !== value.form_id || !recent(Date.parse(value.submitted_at), CONTEXT_TTL) ||
        !["pending", "accepted", "denied_pending", "denied", "rejected"].includes(value.status)) return null;
    const attempts = Number.isInteger(value.attempts) && value.attempts >= 0 ? value.attempts : 0;
    const clean = { reference: value.reference, email_sha256: value.email_sha256, submitted_at: value.submitted_at,
      form_id: value.form_id, page_path: value.page_path, status: value.status,
      attempts: Math.min(attempts, CONTEXT_MAX_TRIES), next_attempt_at: Number.isFinite(value.next_attempt_at) ? value.next_attempt_at : 0 };
    const m = value.measurement;
    if (m && m.analytics_consent === true && typeof m.ad_user_data === "boolean" &&
        m.ga_measurement_id === GA4 && /^[0-9]{1,20}\.[0-9]{1,20}$/.test(m.ga_client_id || "") &&
        /^[1-9][0-9]{0,12}$/.test(m.ga_session_id || "") && recent(Date.parse(m.ga_identity_captured_at), CONTEXT_TTL)) {
      clean.measurement = { analytics_consent: true, ad_user_data: m.ad_user_data,
        ga_client_id: m.ga_client_id, ga_session_id: m.ga_session_id,
        ga_measurement_id: GA4, ga_identity_captured_at: m.ga_identity_captured_at };
    }
    return clean;
  }
  function changeContext(id, update) {
    const value = readContext(id);
    if (!value) return false;
    update(value);
    return saveContext(id, value);
  }
  function restricted(id, purpose) {
    const key = DENIAL_KEYS[purpose] + id, raw = window.localStorage.getItem(key);
    if (raw === null) return false;
    try {
      const value = JSON.parse(raw), submitted = Date.parse(value.submitted_at);
      if (value.version !== 1 || !Number.isFinite(submitted) || value.expires_at !== submitted + CONTEXT_TTL) return true;
      // Only expiry may remove a restriction. Grant writers never clear it.
      if (Date.now() > value.expires_at) { window.localStorage.removeItem(key); return false; }
      return true;
    } catch (_) { return true; }
  }
  function restrict(id, purpose, ctx) {
    try {
      if (restricted(id, purpose)) return true;
      const submitted = Date.parse(ctx.submitted_at);
      if (!recent(submitted, CONTEXT_TTL)) return false;
      window.localStorage.setItem(DENIAL_KEYS[purpose] + id, JSON.stringify({ version: 1,
        submitted_at: ctx.submitted_at, expires_at: submitted + CONTEXT_TTL }));
      return restricted(id, purpose);
    } catch (_) { return false; }
  }
  function overlayRestrictions(id, value) {
    if (restricted(id, "analytics")) {
      if (value.status !== "denied" && value.status !== "denied_pending") {
        value.status = "denied_pending"; value.attempts = 0; value.next_attempt_at = 0;
      }
      delete value.measurement;
    } else if (restricted(id, "ads") && value.measurement && value.measurement.ad_user_data) {
      value.measurement.ad_user_data = false;
      if (!["denied", "denied_pending"].includes(value.status)) value.status = "pending";
      value.attempts = 0; value.next_attempt_at = 0;
    }
    return value;
  }
  function readContext(id) {
    try {
      if (!validNonce(id)) return null;
      const value = cleanContext(JSON.parse(window.localStorage.getItem(CONTEXT_KEY + id)));
      return value && value.reference === reference(id) ? overlayRestrictions(id, value) : null;
    } catch (_) { return null; }
  }
  function saveContext(id, value) {
    try {
      let encoded = JSON.stringify(overlayRestrictions(id, value));
      window.localStorage.setItem(CONTEXT_KEY + id, encoded);
      // A separate tombstone survives another tab's stale grant write.
      const restrictedValue = JSON.stringify(overlayRestrictions(id, value));
      if (restrictedValue !== encoded) {
        encoded = restrictedValue; window.localStorage.setItem(CONTEXT_KEY + id, encoded);
      }
      return window.localStorage.getItem(CONTEXT_KEY + id) === encoded;
    } catch (_) { return false; }
  }
  function contextIds() {
    const ids = [];
    try {
      const keys = [];
      for (let i = 0; i < window.localStorage.length; i++) {
        const key = window.localStorage.key(i);
        if (key && key.startsWith(CONTEXT_KEY)) keys.push(key);
      }
      keys.forEach(key => {
        for (const purpose of Object.keys(DENIAL_KEYS)) {
          if (key.startsWith(DENIAL_KEYS[purpose])) {
            const restrictionId = key.slice(DENIAL_KEYS[purpose].length);
            if (validNonce(restrictionId)) restricted(restrictionId, purpose);
            return;
          }
        }
        const id = key.slice(CONTEXT_KEY.length);
        if (!validNonce(id)) return;
        if (!readContext(id)) window.localStorage.removeItem(key);
        else if (ids.length < MAX_RECORDS) ids.push(id);
      });
    } catch (_) {}
    return ids;
  }
  function retainCompletedContexts(choice) {
    if (choice === "unresolved") return;
    const journal = load();
    if (!journal) return;
    let count = contextIds().length, changed = false;
    Object.keys(journal.outcomes).forEach(id => {
      const item = journal.outcomes[id], ctx = item.context;
      if (!ctx) return;
      let retained = readContext(id);
      if (!retained && count < MAX_RECORDS) {
        if (item.status === "denied" || choice === "denied") ctx.status = "denied_pending";
        if (saveContext(id, ctx)) { retained = ctx; count++; }
      }
      if (retained) { delete item.context; changed = true; }
    });
    if (changed) save(journal);
  }
  function deliverContext(id, choice) {
    const ctx = readContext(id);
    const pending = inflight.get(id);
    const analyticsDenied = choice === "denied" || (ctx && ["denied", "denied_pending"].includes(ctx.status));
    let adsDenied = analyticsChoice(5) === "denied";
    try { adsDenied = adsDenied || restricted(id, "ads"); } catch (_) { adsDenied = true; }
    if (pending && !pending.denial && (analyticsDenied || (pending.ad_user_data && adsDenied))) pending.abort.abort();
    if (!ctx) return false;
    if (analyticsDenied && !restrict(id, "analytics", ctx)) return false;
    if (adsDenied && !restrict(id, "ads", ctx)) return false;
    if (ctx.status === "denied") return false;
    if (choice === "denied" && ctx.status !== "denied_pending") {
      if (!changeContext(id, value => { value.status = "denied_pending"; value.attempts = 0; value.next_attempt_at = 0; delete value.measurement; })) return false;
      ctx.status = "denied_pending"; ctx.attempts = 0; ctx.next_attempt_at = 0;
      delete ctx.measurement;
    } else if (ctx.measurement && ctx.measurement.ad_user_data && analyticsChoice(5) === "denied") {
      if (!changeContext(id, value => {
        value.measurement.ad_user_data = false;
        if (value.status !== "denied_pending") value.status = "pending";
        value.attempts = 0; value.next_attempt_at = 0;
      })) return false;
      ctx.measurement.ad_user_data = false; ctx.status = "pending"; ctx.attempts = 0; ctx.next_attempt_at = 0;
    }
    const denial = ctx.status === "denied_pending";
    if (!denial && (["accepted", "rejected"].includes(ctx.status) || choice !== "granted")) return false;
    if (!denial && !ctx.measurement && !recent(Date.parse(ctx.submitted_at), OUTCOME_TTL)) return false;
    if (inflight.has(id) || ctx.attempts >= CONTEXT_MAX_TRIES || Date.now() < ctx.next_attempt_at) return true;
    let measurement = { analytics_consent: false };
    if (!denial) {
      const controller = window.DRSKNN_GOOGLE_MEASUREMENT;
      if (!controller || controller.measurementId !== GA4 || typeof controller.getIdentity !== "function" ||
          (window.DRSKNN_CONSENT_STATE || {}).analytics !== true) return true;
      const identity = ctx.measurement || controller.getIdentity();
      if (!identity || identity.analytics_consent !== true || identity.ga_measurement_id !== GA4 ||
          !/^[0-9]{1,20}\.[0-9]{1,20}$/.test(identity.ga_client_id || "") ||
          !/^[1-9][0-9]{0,12}$/.test(identity.ga_session_id || "") ||
          !recent(Date.parse(identity.ga_identity_captured_at), ctx.measurement ? CONTEXT_TTL : ATTEMPT_TTL)) return true;
      measurement = { analytics_consent: true, ad_user_data: identity.ad_user_data === true && analyticsChoice(5) === "granted" && !adsDenied,
        ga_client_id: identity.ga_client_id, ga_session_id: identity.ga_session_id,
        ga_measurement_id: GA4, ga_identity_captured_at: identity.ga_identity_captured_at };
    }
    if (typeof window.fetch !== "function" || typeof window.AbortController !== "function") return true;
    const attempt = ctx.attempts + 1;
    if (!changeContext(id, value => {
      if (!denial) value.measurement = measurement;
      value.attempts = attempt;
      value.next_attempt_at = Date.now() + Math.min(CONTEXT_RETRY_MAX, 1000 * Math.pow(2, attempt - 1));
    })) return true;
    const body = { protocol_version: 1, website_enquiry_reference: ctx.reference, form_id: ctx.form_id,
      page_path: ctx.page_path, submitted_at: ctx.submitted_at, person_email_sha256: ctx.email_sha256,
      test_mode: false, measurement_context: measurement };
    const abort = new window.AbortController();
    inflight.set(id, { abort: abort, denial: denial, ad_user_data: measurement.ad_user_data === true });
    const timeout = window.setTimeout(() => abort.abort(), 10000);
    Promise.resolve().then(() => {
      // Recheck immediately before transport: consent may change before this microtask.
      const latest = readContext(id);
      if (abort.signal.aborted || !latest || (denial ? latest.status !== "denied_pending" :
          latest.status !== "pending" || !latest.measurement || latest.measurement.ad_user_data !== measurement.ad_user_data ||
          analyticsChoice() !== "granted" || (window.DRSKNN_CONSENT_STATE || {}).analytics !== true ||
          (measurement.ad_user_data && analyticsChoice(5) !== "granted"))) throw new Error("Context request superseded");
      return window.fetch(CONTEXT_URL, { method: "POST", mode: "cors", credentials: "omit",
      redirect: "error", referrerPolicy: "no-referrer", headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body), signal: abort.signal });
    }).then(async response => {
      if (response.status === 202) {
        const receipt = await response.json();
        if (!receipt || receipt.reference !== ctx.reference || !["accepted", "duplicate", "suppressed"].includes(receipt.status)) return;
        if (receipt.status === "suppressed" && !restrict(id, "analytics", ctx)) return;
        changeContext(id, value => {
          if (receipt.status === "suppressed") { value.status = "denied"; delete value.measurement; return; }
          if (denial) { if (value.status === "denied_pending") { value.status = "denied"; delete value.measurement; } }
          else if (value.status === "pending" && value.measurement && value.measurement.ad_user_data === measurement.ad_user_data) value.status = "accepted";
        });
      } else if ([400,403,404,409,410,422].includes(response.status)) {
        changeContext(id, value => { if (value.status === ctx.status) value.status = "rejected"; });
      }
    }).catch(() => {}).finally(() => {
      window.clearTimeout(timeout); inflight.delete(id); pump();
    });
    return true;
  }

  function nonce() {
    try {
      const bytes = new Uint8Array(16);
      window.crypto.getRandomValues(bytes);
      return Array.from(bytes, value => value.toString(16).padStart(2, "0")).join("");
    } catch (_) { return ""; }
  }
  const documentNonce = nonce();
  const validNonce = value => typeof value === "string" && /^[a-f0-9]{32}$/.test(value);
  const recent = (stamp, limit) => Number.isFinite(stamp) && Date.now() >= stamp && Date.now() - stamp <= limit;

  function load() {
    try {
      const raw = window.sessionStorage.getItem(KEY);
      const value = raw ? JSON.parse(raw) : { version: 1, attempts: {}, outcomes: {} };
      if (!value || value.version !== 1 || !value.attempts || !value.outcomes ||
          Object.keys(value.attempts).length > 2 || Object.keys(value.outcomes).length > MAX_RECORDS) return null;
      const clean = { version: 1, attempts: {}, outcomes: {} };
      Object.keys(FORMS).forEach(function (formPath) {
        const id = FORMS[formPath], item = value.attempts[id];
        if (item && item.form_id === id && item.path === formPath && item.origin === window.location.origin &&
            validNonce(item.nonce) && validNonce(item.source_document) && recent(item.created_at, ATTEMPT_TTL)) {
          clean.attempts[id] = { nonce: item.nonce, source_document: item.source_document, created_at: item.created_at,
            departed_at: Number.isFinite(item.departed_at) ? item.departed_at : null, path: formPath, form_id: id, origin: item.origin };
          const ctx = cleanContext(item.context);
          if (ctx && ctx.reference === reference(item.nonce) && ctx.form_id === id) clean.attempts[id].context = ctx;
        }
      });
      Object.keys(value.outcomes).forEach(function (id) {
        const item = value.outcomes[id];
        if (validNonce(id) && item && recent(item.created_at, OUTCOME_TTL) &&
            ["pending", "queued", "denied", "expired"].includes(item.status)) {
          clean.outcomes[id] = { created_at: item.created_at, status: item.status };
          const ctx = cleanContext(item.context);
          if (ctx && ctx.reference === reference(id)) clean.outcomes[id].context = ctx;
        }
      });
      return clean;
    } catch (_) { return null; }
  }
  function save(value) {
    try {
      const encoded = JSON.stringify(value);
      window.sessionStorage.setItem(KEY, encoded);
      return window.sessionStorage.getItem(KEY) === encoded;
    } catch (_) { return false; }
  }
  function analyticsChoice(purpose = 4) {
    try {
      const api = window._iub && window._iub.cs && window._iub.cs.api;
      if (!api || typeof api.isPreferenceExpressed !== "function" || api.isPreferenceExpressed() !== true ||
          typeof api.getPreferences !== "function") return "unresolved";
      const preferences = api.getPreferences();
      if (!preferences || !preferences.purposes) return "unresolved";
      const raw = preferences.purposes[purpose];
      return raw === true || (raw && typeof raw === "object" &&
        (raw.consent === true || raw.value === true || raw.enabled === true)) ? "granted" : "denied";
    } catch (_) { return "unresolved"; }
  }
  function pump() {
    if (timer !== null) window.clearTimeout(timer);
    timer = null;
    const journal = load() || { outcomes: {} };
    const choice = analyticsChoice();
    let remains = false;
    Object.keys(journal.outcomes).forEach(function (id) {
      const item = journal.outcomes[id];
      if (item.status !== "pending") return;
      if (choice === "denied") { item.status = "denied"; save(journal); return; }
      remains = true;
      if (choice !== "granted" || (window.DRSKNN_CONSENT_STATE || {}).analytics !== true) return;
      const controller = window.DRSKNN_GOOGLE_MEASUREMENT;
      if (!controller || controller.measurementId !== GA4 || typeof controller.isLibraryReady !== "function" ||
          controller.isLibraryReady() !== true || typeof window.gtag !== "function") return;
      // Persist first: an invocation that throws can already be queued by Google.
      item.status = "queued";
      if (!save(journal)) { item.status = "pending"; return; }
      try {
        window.gtag("event", "generate_lead", { send_to: GA4, event_id: "shopify_enquiry:" + id,
          page_location: "https://drsknn.com/", page_path: "/", page_title: "Dr Sknn", page_referrer: "",
          allow_google_signals: false, allow_ad_personalization_signals: false });
      } catch (_) {}
    });
    retainCompletedContexts(choice);
    contextIds().forEach(function (id) {
      if (deliverContext(id, choice)) remains = true;
    });
    if (remains && Date.now() < activeUntil) timer = window.setTimeout(pump, 1000);
  }
  function wake() { activeUntil = Date.now() + 5 * 60 * 1000; pump(); }
  function initForm() {
    if (!documentNonce || !FORMS[path]) return;
    const form = document.getElementById(FORMS[path]);
    if (!form || form.tagName !== "FORM" || String(form.method).toLowerCase() !== "post") return;
    try {
      const action = new URL(form.action, window.location.href);
      if (action.origin !== window.location.origin || action.pathname !== "/contact" || action.hash !== "#" + form.id) return;
    } catch (_) { return; }
    const marker = status => form.querySelector('[data-drsknn-enquiry-status="' + status + '"][data-drsknn-enquiry-form="' + form.id + '"][data-drsknn-enquiry-version="1"]');
    const journal = load(), attempt = journal && journal.attempts[form.id];
    if (attempt && marker("error")) {
      delete journal.attempts[form.id];
      save(journal);
    } else if (attempt && marker("success") && attempt.source_document !== documentNonce &&
               attempt.departed_at !== null && attempt.departed_at >= attempt.created_at &&
               recent(attempt.departed_at, ATTEMPT_TTL)) {
      let navigation = null;
      try { navigation = window.performance.getEntriesByType("navigation")[0]; } catch (_) {}
      if (navigation && navigation.type === "navigate") {
        if (!journal.outcomes[attempt.nonce] && Object.keys(journal.outcomes).length < MAX_RECORDS) {
          journal.outcomes[attempt.nonce] = { created_at: Date.now(), status: "pending" };
          if (attempt.context) journal.outcomes[attempt.nonce].context = attempt.context;
        }
        delete journal.attempts[form.id];
        save(journal);
      }
    }
    // Add only the enquiry reference. Shopify retains native validation, hCaptcha and POST.
    form.addEventListener("submit", function (event) {
      if (event.isTrusted !== true || event.target !== form) return;
      const current = load();
      if (!current) return;
      const existing = current.attempts[form.id];
      if (existing && existing.source_document === documentNonce) {
        // A challenge may cancel native submission while this document stays open.
        // Retain its reference but match the email actually posted on the retry.
        if (existing.departed_at === null) {
          const retry = captureEnquiry(form, existing.nonce);
          if (retry) existing.context = retry;
          else delete existing.context;
          save(current);
        }
        return;
      }
      const id = nonce();
      if (!id) return;
      current.attempts[form.id] = { nonce: id, source_document: documentNonce, created_at: Date.now(),
        departed_at: null, path: path, form_id: form.id, origin: window.location.origin };
      const ctx = captureEnquiry(form, id);
      if (ctx) current.attempts[form.id].context = ctx;
      save(current);
    }, true);
    window.addEventListener("pagehide", function () {
      const current = load(), item = current && current.attempts[form.id];
      if (item && item.source_document === documentNonce) { item.departed_at = Date.now(); save(current); }
    });
  }
  function init() {
    initForm();
    window.addEventListener("drsknn:consent-ready", wake);
    window.addEventListener("drsknn:google-library-ready", wake);
    window.addEventListener("drsknn:google-identity-ready", wake);
    window.addEventListener("pageshow", wake);
    window.addEventListener("storage", function (event) {
      if (event.key && event.key.startsWith(CONTEXT_KEY)) wake();
    });
    wake();
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init, { once: true });
  else init();
})(window, document);
